/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { CassiereCreationForm } from '../model/models';
import { CassiereDTO } from '../model/models';
import { CassiereNegoziReplaceForm } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelCassiereDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface AssegnaNegoziCassiereEsercenteRequestParams {
    idCassiere: string;
    cassiereNegoziReplaceForm: CassiereNegoziReplaceForm;
}

export interface CreaCassiereEsercenteRequestParams {
    cassiereCreationForm: CassiereCreationForm;
}

export interface DeleteCassiereEsercenteRequestParams {
    idCassiere: string;
}

export interface GetCassiereEsercenteRequestParams {
    idCassiere: string;
}

export interface ListCassieriEsercenteRequestParams {
    pageable: Pageable;
}

export interface PatchEnableCassiereEsercenteRequestParams {
    idCassiere: string;
    enable: boolean;
}

export interface PatchNegozioCassiereEsercenteRequestParams {
    idCassiere: string;
    idNegozio: string;
    aggiungi: boolean;
}


export interface EsercenteCassieriServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Sostituisce l\&#39;insieme dei negozi di un cassiere (sposta tra i punti vendita).
     * Replace dell\&#39;intero insieme di negozi assegnati. Insieme vuoto → 422 (min 1 negozio, no cassiere orfano). Ogni negozio deve appartenere all\&#39;impresa del caller (404 altrimenti).
     * @endpoint put /api/v1/esercente/cassieri/{id_cassiere}/negozi
* @param requestParameters
     */
    assegnaNegoziCassiereEsercente(requestParameters: AssegnaNegoziCassiereEsercenteRequestParams, extraHttpRequestParams?: any): Observable<CassiereDTO>;

    /**
     * Crea un cassiere (onboarding via email).
     * Crea un User con authority CASSIERE (account inerte + mail di attivazione). Email &#x3D;&#x3D; propria → aggiunge l\&#39;authority al proprio account; email &#x3D;&#x3D; altro User → 422 (anti-escalation). L\&#39;assegnazione ai negozi è un asse separato (PUT .../negozi).
     * @endpoint post /api/v1/esercente/cassieri
* @param requestParameters
     */
    creaCassiereEsercente(requestParameters: CreaCassiereEsercenteRequestParams, extraHttpRequestParams?: any): Observable<CassiereDTO>;

    /**
     * Rimuove un cassiere (l\&#39;account resta).
     * Rimuove l\&#39;authority CASSIERE + tutte le assegnazioni ai negozi e revoca le sessioni, ma NON cancella lo User (protegge il titolare-che-è-anche-cassiere). 404 se di un\&#39;altra impresa.
     * @endpoint delete /api/v1/esercente/cassieri/{id_cassiere}
* @param requestParameters
     */
    deleteCassiereEsercente(requestParameters: DeleteCassiereEsercenteRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Dettaglio di un proprio cassiere.
     * Ritorna il cassiere con i negozi assegnati e lo stato di attivazione. 404 se di un\&#39;altra impresa.
     * @endpoint get /api/v1/esercente/cassieri/{id_cassiere}
* @param requestParameters
     */
    getCassiereEsercente(requestParameters: GetCassiereEsercenteRequestParams, extraHttpRequestParams?: any): Observable<CassiereDTO>;

    /**
     * Elenca i propri cassieri.
     * Ritorna una Page dei cassieri assegnati a negozi del proprio ProfiloEsercente, con stato di attivazione e negozi assegnati. Il caller stesso NON compare nella lista.
     * @endpoint get /api/v1/esercente/cassieri
* @param requestParameters
     */
    listCassieriEsercente(requestParameters: ListCassieriEsercenteRequestParams, extraHttpRequestParams?: any): Observable<PagedModelCassiereDTO>;

    /**
     * Sospende/riabilita un cassiere.
     * ?enable&#x3D;false sospende (revoca le sessioni/token attivi) e ?enable&#x3D;true riabilita. Vietato l\&#39;auto-disable del caller. 404 se di un\&#39;altra impresa.
     * @endpoint put /api/v1/esercente/cassieri/{id_cassiere}/enable
* @param requestParameters
     */
    patchEnableCassiereEsercente(requestParameters: PatchEnableCassiereEsercenteRequestParams, extraHttpRequestParams?: any): Observable<CassiereDTO>;

    /**
     * Aggiunge/rimuove un singolo negozio dallo scope del cassiere.
     * ?aggiungi&#x3D;true aggiunge (no-op idempotente se già presente), false rimuove la coppia. Owner-check su cassiere e negozio (404 altrimenti).
     * @endpoint patch /api/v1/esercente/cassieri/{id_cassiere}/negozi/{id_negozio}
* @param requestParameters
     */
    patchNegozioCassiereEsercente(requestParameters: PatchNegozioCassiereEsercenteRequestParams, extraHttpRequestParams?: any): Observable<CassiereDTO>;

}
